<template>
  <v-content
    id="pages"
    :class="$vuetify.theme.dark ? undefined : 'grey lighten-3'"
  >
    <v-img
      :src='backgroundSrc'
    > <!-- max-height="100vh" -->
      <v-responsive
        min-height="100vh"
        class="d-flex align-center"
      >
        <router-view />
      </v-responsive>
    </v-img>
  </v-content>
</template>

<script>
import backgroundDesktop from '@/assets/background-desktop.png';
import backgroundMobile from '@/assets/background-mobile.png';

  export default {
    name: 'PagesCoreView',

    data: () => ({
      srcs: {
        '/pages/lock': 'lock.jpg',
        '/pages/login': 'login.jpg',
        '/pages/pricing': 'pricing.jpg',
        '/pages/register': 'register.jpg',
      },
    }),

    computed: {
      src () {
        return this.srcs[this.$route.path]
      },
      styles () {
        const paddingTop = this.$vuetify.breakpoint.mdAndUp ? 20 : 0
        const paddingBottom = this.$vuetify.breakpoint.mdAndUp ? 20 : 0
        return {
          padding: `${paddingTop}px 0 ${paddingBottom}px 0`,
        }
      },
      backgroundSrc() {
        const isMobile = this.$vuetify.breakpoint.smAndDown;
        return isMobile ? backgroundMobile : backgroundDesktop;
      }
    },
  }
</script>
